import(/* webpackMode: "eager", webpackExports: ["CtaButtons"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/app/zenthor/comparativo/CtaButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTracker"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/app/zenthor/comparativo/ViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/hannah/Documentos/Vorseum/vorseum_institucional/node_modules/next/dist/client/image-component.js");
